/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const userAccount = {
  loginForm: {
    forgotPassword: 'Forgot password?',
    signIn: 'Sign In',
    register: 'Register',
    dontHaveAccount: 'Don’t have an account?',
    guestCheckout: 'Guest Checkout',
    emailAddress: {
      label: 'Email address',
      placeholder: 'Enter email',
    },
    password: {
      label: 'Password',
      placeholder: 'Password',
    },
    wrongEmailFormat: 'This is not a valid email format.',
  },
  miniLogin: {
    userGreeting: 'Hi, {{name}}',
    signInRegister: 'Sign In / Register',
  },
};
